import { useQuery } from '@tanstack/react-query';
import {
  TransferWithEvidenceService,
  GetTransferRequestDetailEntity,
} from 'services/openapi';
import { BidvTransferWithEvidenceQueryKeys } from './constants';

export const useGetTransferRequestDetailQuery = (
  id: string,
  enabled = true,
) => {
  const queryKey = [
    BidvTransferWithEvidenceQueryKeys.GET_TRANSFER_REQUEST_DETAIL,
    id,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetTransferRequestDetailEntity, Error>({
    queryKey,
    queryFn: () =>
      TransferWithEvidenceService.transferWithEvidenceControllerGetDetail(id),
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: enabled && !!id,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
